
// ==========================================================================
// FILE: /app/components/onboarding/steps/ThirdPartyStep.tsx
// ==========================================================================
import { type FC } from "react";
 
const ThirdPartyStep: FC = () => (
  <div className="p-8 bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl border-2 border-amber-200">
    <div className="flex items-start gap-5">
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-amber-200">
        <svg
          className="h-6 w-6 text-amber-700"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 10V3L4 14h7v7l9-11h-7z"
          />
        </svg>
      </div>
      <div>
        <h3 className="gx-h3-b text-gray-900">Third-Party Services</h3>
        <p className="gx-p14-r text-gray-700 leading-relaxed mt-3">
          Connect accounting, payroll, or other third-party services to your
          workspace. Placeholder step — wire up the real integrations list here
          once it's ready.
        </p>
      </div>
    </div>
  </div>
);
 
export default ThirdPartyStep;